import { TenantEntity } from '../TenantEntity'

export class EntityDefaultValue extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }
  get userId() {
    return this._data.userId
  }
  set userId(userId) {
    this._data.userId = userId
  }
  get entityCode() {
    return this._data.entityCode
  }
  set entityCode(entityCode) {
    this._data.entityCode = entityCode
  }
  get entityName() {
    return this._data.entityName
  }
  set entityName(entityName) {
    this._data.entityName = entityName
  }
  get fieldCode() {
    return this._data.fieldCode
  }
  set fieldCode(fieldCode) {
    this._data.fieldCode = fieldCode
  }
  get fieldName() {
    return this._data.fieldName
  }
  set fieldName(fieldName) {
    this._data.fieldName = fieldName
  }
  get valueType() {
    return this._data.valueType
  }
  set valueType(valueType) {
    this._data.valueType = valueType
  }
  get defaultValue() {
    return this._data.defaultValue
  }
  set defaultValue(defaultValue) {
    this._data.defaultValue = defaultValue
  }
  get seDefaultValue() {
    return this._data.seDefaultValue
  }
  set seDefaultValue(seDefaultValue) {
    this._data.seDefaultValue = seDefaultValue
  }
  get siDefaultValue() {
    return this._data.siDefaultValue
  }
  set siDefaultValue(siDefaultValue) {
    this._data.siDefaultValue = siDefaultValue
  }
  get aeDefaultValue() {
    return this._data.aeDefaultValue
  }
  set aeDefaultValue(aeDefaultValue) {
    this._data.aeDefaultValue = aeDefaultValue
  }
  get aiDefaultValue() {
    return this._data.aiDefaultValue
  }
  set aiDefaultValue(aiDefaultValue) {
    this._data.aiDefaultValue = aiDefaultValue
  }
  get reDefaultValue() {
    return this._data.reDefaultValue
  }
  set reDefaultValue(reDefaultValue) {
    this._data.reDefaultValue = reDefaultValue
  }
  get riDefaultValue() {
    return this._data.riDefaultValue
  }
  set riDefaultValue(riDefaultValue) {
    this._data.riDefaultValue = riDefaultValue
  }
  get officeCnName() {
    return this._data.officeCnName
  }
  set officeCnName(officeCnName) {
    this._data.officeCnName = officeCnName
  }
  get officeEnName() {
    return this._data.officeEnName
  }
  set officeEnName(officeEnName) {
    this._data.officeEnName = officeEnName
  }
}
